import React from 'react'
import Carousel from 'react-bootstrap/Carousel';
import Style from './Inf.module.css'
import infra1 from '../img/infrastructure1.png'
import infra2 from '../img/infrastructure2.jpg'
import infra3 from '../img/infrastructure3.jpg'

const Inf = () => {
    return (
        <>
            <Carousel className={Style.slider}>
                <Carousel.Item >
                    <img
                        className="d-block w-100"
                        src={ infra1 }
                        alt="First slide"
                    />

                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src={ infra2 }
                        alt="Second slide"
                    />

                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src={ infra3 }
                        alt="Third slide"
                    />
                </Carousel.Item>
            </Carousel>

            <div className={ Style.bio }>
                <h6 className={ Style.about }>Our Team</h6>
                <br />
                <hr /><br />
                <p>👉We have all facilities in-house to provide best quality imitation jari. Our dedicated workforce consists of skilled professionals working in various capacities in various departments such as Production, Administration, Finance, Marketing and others. All working under the able guidance of our promoters.</p>

                <hr /><br />
                <p>👉We also have fully equipped lab required for providing best quality imitation jari to meet the requirements of our esteemed patrons. We have all process from doubling of yarn to dyeing of yarn in fully automatic plant and covering of yarn in-house to satisfy our client requirements in best possible way and for also delivering the goods on right time without any delay.</p>

                <hr /><br />
                <p>👉Customer satisfaction is our prime motto. We also believe in providing best after sales service to our valuable clients. For us just to manufacture and deliver the goods is not completion of trade but also the long term relationship and continuous work is what matters to us.</p>

                <hr /><br />
            </div>
        </>
    )
}

export default Inf
